import { NoPermissions } from "./NoPermissions";

export default NoPermissions;
